import { BaseRequestQueryParam, HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';
import {
  createP2pTransaction,
  P2pTransaction,
  SearchUserRequest,
  SearchUserResponse,
} from 'models/transfer';

const transferApi = {
  searchUser: (request: SearchUserRequest): Promise<HttpResponse<SearchUserResponse>> => {
    const url = `/terabet/api/users/search-user`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  createOrder: (request: createP2pTransaction) => {
    const url = `/wallet/api/transaction/p2p`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getTransaction: (params: BaseRequestQueryParam): Promise<HttpResponse<P2pTransaction[]>> => {
    const url = `/wallet/api/transaction/p2p`;
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
};

export default transferApi;
